import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { WebAccessControlCustomPagesFormFactory } from '../factory/WebAccessControlCustomPagesFormFactory';
import { WebAccessControlCustomPagesFormBaseDataProvider } from '../dataProvider/WebAccessControlCustomPagesFormBaseDataProvider';
import { WacPagesRecord } from '../../webAccessControlCustomPagesApp/types';

export class WebAccessControlCustomPagesFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: WebAccessControlCustomPagesFormFactory;
  public dataProvider: WebAccessControlCustomPagesFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new WebAccessControlCustomPagesFormFactory(),
    });
  }

  public async getSuggestedFieldValue() {
    return this.dataProvider.getSuggestedFieldValue();
  }

  public async createRecords(records: Array<WacPagesRecord>) {
    return this.dataProvider.createRecords(records);
  }

  public async updateRecords(records: Array<WacPagesRecord>) {
    return this.dataProvider.updateRecords(records);
  }
}
